import { combineReducers } from "redux";
import authReducer from "./authReducer";
import searchReducer from "./searchReducer";
import historyReducer from "./historyReducer";
import currentSelectionReducer from "./currentSelectionReducer";
import manifestReducer from "./manifestReducers";
import landingPageCount from "./landingPageCountReducer";

export default combineReducers({
  user: authReducer,
  search: searchReducer,
  manifest: manifestReducer,
  history: historyReducer,
  currentSelection: currentSelectionReducer,
  landingPageCount: landingPageCount,
});
